import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';

export const ErrorModal = ({ open, handleClose, message, title = 'Error' }) => {
    const _handleConfirm = () => {
        handleClose && handleClose();
    };

    return (
        <div>
            <Dialog
                open={open}
                // onClose={_handleCancel}
                aria-labelledby='alert-dialog-title'
                aria-describedby='alert-dialog-description'
            >
                {title && (
                    <div
                        className='page-header'
                        role='banner'
                    >
                        <h2
                            style={{
                                height: '50px',
                                marginTop: '15px',
                                marginLeft: '15px',
                            }}
                        >
                            <FontAwesomeIcon icon={faExclamationTriangle} /> {title}
                        </h2>
                    </div>
                )}
                <DialogContent>
                    <DialogContentText id='alert-dialog-description'>
                        <div
                            style={{ color: 'darkred' }}
                            dangerouslySetInnerHTML={{ __html: message }}
                        ></div>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <div className='row'>
                        <button
                            type='button'
                            className='button primary'
                            onClick={_handleConfirm}
                        >
                            Close
                        </button>
                    </div>
                </DialogActions>
            </Dialog>
        </div>
    );
};
